export default __webpack_public_path__ + "static/media/get-connected.04655ca8.svg";